import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { confirmEventName: { type: String, default: 'modal:confirm' } }

  connect() {
    this.modal = new bootstrap.Modal(this.element, {})
    this.modal.show()
  }

  hide() {
    this.modal.hide()
  }

  // disconnect() {
  //   console.log('modal | disconnect')
  // }

  // on click Cancel or Close
  dismiss() {
    this._dispatchDismiss()
  }

  renderTurboStreamFromUrl(url, action = 'replace') {
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(r => r.text())
    .then(html => {
      html = `<turbo-stream action="${action}" target="modal"><template>${html}</template></turbo-stream>`
      Turbo.renderStreamMessage(html)
    })
  }

  _dispatchDismiss() {
    const custom_event = new CustomEvent('modal:dismiss')
    window.dispatchEvent(custom_event)
  }
}
